/**我的订单**/
<template>
  <div class="recordDaiJia">
    <v5-mirco-tabs :tabs="tabs" :active.sync="active"></v5-mirco-tabs>
    <div class="daijiaContent">
      <div class="contentList" v-if="orderList&&orderList.length>0">
        <div class="ListItem" v-for="(item, index) in orderList" :key="index" @click="clickFn(item)">
          <div class="itemContent">
            <div class="item-row">
              <div class="itemTime">{{item.orderTypeName}}</div>
              <div class="itemStatus">
                <i class="iconfont icon-jiantou"></i>
                <span class="text " :class="item.status === 1 ? 'textRed': 'textAsh'">{{item.status | orderStatusFilter}}</span>
              </div>
            </div>
            <div class="item-time">
              <i class="iconfont icon-shijian1"></i>
              <span class="site">{{item.book_time | time}}</span>
            </div>
            <div class="item-address">
              <i class="yuan"></i>
              <span class="site">{{item.book_address}}</span>
            </div>
            <div class="item-address">
              <i class="yuan color-red"></i>
              <span class="site">{{item.destination}}</span>
            </div>
            <div class="item-order" v-if="item.order_no">
              <span class="site">订单号：{{item.order_no}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="NullOrder" v-else="">
        <div class="img">
          <img src="../../assets/img/yonghu/orderImg.png"/>
          <span class="imgBut"><router-link to="/daijia">去下单</router-link></span>
        </div>
      </div>
      <div class="loadDataBut" v-if="orderList&&orderList.length<total&&orderList.length>0">
        <span @click="loadDataButFn">点击加载更多</span>
      </div>
    </div>
    <xk-upload-mod :state="loadState"></xk-upload-mod>
  </div>
</template>

<script>
  import XkRecordOrderMod from '../module/recordOrderMod/src/recordOrderMod'
  import XkUploadMod from '../module/uploadMod/src/uploadMod'
  import V5MircoTabs from '../components/tabs/tabs'
  import JSONBig from 'json-bigint-xk'

  export default {
    components: {
      XkUploadMod,
      XkRecordOrderMod,
      V5MircoTabs
    },
    name: 'recordDaiJia',
    computed: {},
    data () {
      return {
        page: 1,
        rows: 10,
        loadState: false,
        pageState: true,
        tabs: [ // tab项内容
          {active: 1, name: '服务中'},
          {active: 2, name: '已完成'},
          {active: 3, name: '已销单'}
        ],
        orderList: [], // 订单列表
        total: 0, // 条数
        status: '1,5,10,15,20,25,28',
        active: 1 // 被选中的项，默认为第一个
      }
    },
    watch: {
      active (val) {
        this.page = 1
        switch (val) {
          case 1:
            this.status = '1,5,10,15,20,25,28'
            break
          case 2:
            this.status = '35,40'
            break
          case 3:
            this.status = '45'
            break
        }
        this.getOrdersFn()
      }
    },
    methods: {
      /**
       * @returns void
       * @desc 获取订单列表
       */
      async getOrdersFn () {
        this.loadState = true
        let appKey = this.$Cookie.get('cookieAppKey')
        let passengerkey = 'passenger' + appKey
        let passenger = this.$Cookie.get(passengerkey) ? JSONBig.parse(this.$Tool.aesDecryptCode(this.$Cookie.get(passengerkey))) : null
        console.log('appKey', appKey, 'passenger', passenger)
        let url = '/v1/orders'
        let params = {
          'app_key': appKey,
          'status': this.status,
          'passenger_id': passenger && passenger.passenger && passenger.passenger.id ? passenger.passenger.id : '',
          'page': this.page,
          'limit': this.rows
        }
        let data = await this.$axios.get(url, params)
        if (data && data.code === 1) {
          let responseData = []
          switch (this.active) {
            case 1:
              responseData = data.runOrders ? data.runOrders : []
              this.total = data.runTotal
              break
            case 2:
              responseData = data.finishOrders ? data.finishOrders : []
              this.total = data.finnishTotal
              break
            case 3:
              responseData = data.cancelOrders ? data.cancelOrders : []
              this.total = data.cancelTotal
              break
          }
          if (this.page === 1) {
            this.orderList = responseData
          } else if (this.page > 1) {
            this.orderList = this.orderList.concat(responseData)
          }
        }
        this.loadState = false
      },
      /**
       * @returns void
       * @desc 点击加载更多去获取更多订单
       */
      loadDataButFn: function () { //  获取更多订单
        this.page++
        this.getOrdersFn()
      },
      /**
       * @returns void
       * @desc 点击各项
       */
      clickFn (item) {
        switch (item.status) {
          case 1:
            this.$router.push({path: '/daijia/await', query: {order_id: item.id}})
            break
          case 5:
            this.$router.push({path: '/daijia/await', query: {order_id: item.id}})
            break
          case 10:
            this.$router.push({path: '/daijia/service', query: {order_id: item.id}})
            break
          case 15:
            this.$router.push({path: '/daijia/service', query: {order_id: item.id}})
            break
          case 20:
            this.$router.push({path: '/daijia/service', query: {order_id: item.id}})
            break
          case 25:
            this.$router.push({path: '/daijia/service', query: {order_id: item.id}})
            break
          case 28:
            this.$router.push({path: '/daijia/service', query: {order_id: item.id}})
            break
          case 30:
            this.$router.push({path: '/daijia/settlement', query: {order_id: item.id}})
            break
          case 35:
            this.$router.push({path: '/daijia/affirm', query: {order_id: item.id}})
            break
          case 40:
            this.$router.push({path: '/daijia/affirm', query: {order_id: item.id, status: item.status}})
            break
          case 45:
            this.$router.push({path: '/daijia/checkOrder', query: {order_id: item.id}})
            break
        }
      }
    },
    created () {
      // let that = this
      // that.$store.dispatch('checkLogin', (state) => {
      //   if (state) {
      //     that.getOrdersFn()
      //   }
      // })
      this.active = this.$route.query.active || 1
      this.getOrdersFn()
    }
  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .recordDaiJia {
    width: 100vw;
    height: 100vh;
    background-color: #f3f4f5;
    .daijiaContent{
      padding-top: 40px;
    }
    .contentList {
      box-sizing: border-box;
      width: 100%;
      padding: 0 0.5rem;
      overflow: hidden;
      overflow-y: auto;
    }

    .NullOrder {
      width: 100%;
      .img {
        position: absolute;
        left: 50%;
        top: 40%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 50%;
        img {
          width: 100%;
        }
        a {
          margin-top: 1rem;
          padding: 0 1rem;
          line-height: 2rem;
          border-radius: 1rem;
          border: 1px solid #f06553;
          color: #f06553;
          text-align: center;
        }
      }
    }

    .loadDataBut {
      box-sizing: border-box;
      width: 100%;
      line-height: 3.5rem;
      padding: 0 1rem;
      margin-bottom: 1rem;
      span {
        width: 100%;
        background-color: #fff;
        border-radius: 0.333rem;
        text-align: center;
      }
    }
    .ListItem {
      box-sizing: border-box;
      width: calc(~'100% - 1rem');
      margin: 1rem 0.5rem;
      padding: 12px 12px 0;
      background-color: #fff;
      border-radius: 0.33333rem;
      overflow: hidden;
      .itemContent {
        .item-title{
          font-size:14px;
          font-weight:500;
          color:rgba(34,34,34,1);
          line-height:20px;
        }
        .item-row{
          height: 20px;
          line-height: 20px;
          margin-bottom: 12px;
          .itemTime {
            float: left;
            font-size:14px;
            font-weight:500;
            color:rgba(34,34,34,1);
            line-height:20px
          }
          .itemStatus {
            float: right;
            display: inline-block;
            .text {
              float: right;
              color: #333;
              margin-right: 0.5rem;
            }
            .textRed {
              color: #f06553;
            }
            .textAsh {
              color: #999999;
            }
          }
          i {
            font-size: 0.8333rem;
            color: #999999;
            float: right;
          }
        }
        .item-time{
          font-size:13px;
          font-weight:400;
          color:rgba(102,102,102,1);
          line-height:18px;
          margin-bottom: 8px;
          .icon-shijian1{
            font-size: 8px;
          }
        }
        .item-address{
          font-size:13px;
          font-weight:400;
          color:rgba(102,102,102,1);
          height: 18px;
          line-height:18px;
          display: flex;
          justify-content: start;
          align-items: center;
          .yuan{
            display: block;
            width: 6px;
            height: 6px;
            background-color: #FFA000;
            border-radius: 50%;
            margin-right: 8px;
          }
          .site{
            display: block;
            line-height:18px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }
        .item-address+.item-address{
          margin-top: 2px;
        }
        .color-red{
          background-color: #FF6577!important;
        }
        .item-order{
          border-top: 1px #EBEBEB solid;
          height: 41px;
          margin-top: 12px;
          .site{
            height: 41px;
            line-height: 41px;
            font-size:12px;
            font-weight:400;
            color:rgba(153,153,153,1);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// orderRecord.vue?5c617806